import {Buffer} from 'buffer';

import {toMongo} from '../../util/filters';

// extracts the numeric project ID from a base64-encoded GraphQL internal project ID.
export function parseInternalProjectId(
  internalProjectId: string
): string | null {
  if (!internalProjectId) {
    return null;
  }

  // The gql api returns project internal IDs in the format
  // "ProjectInternalId:123" encoded as base64.
  const mProjectId = Buffer.from(internalProjectId, 'base64')
    .toString()
    .match(/^ProjectInternalId:(\d+)$/);
  return mProjectId ? mProjectId[1] : null;
}

export function createProjectIdFilter(
  internalProjectId: string
): string | undefined {
  const projectId = parseInternalProjectId(internalProjectId);

  if (!projectId) {
    return undefined;
  }

  return JSON.stringify(
    toMongo({
      op: '=',
      key: {
        section: 'run',
        name: 'project_id',
      },
      value: projectId,
    })
  );
}

// extracts the artifact collection ID from a base64-encoded GraphQL ID.
function parseArtifactCollectionId(
  internalArtifactCollectionId: string
): string | null {
  if (!internalArtifactCollectionId) {
    return null;
  }

  try {
    // The GraphQL API returns artifact collection IDs in the format
    // "ArtifactCollection:123456" encoded as base64.
    const decoded = Buffer.from(
      internalArtifactCollectionId,
      'base64'
    ).toString();
    const match = decoded.match(/^ArtifactCollection:(\d+)$/);
    return match ? match[1] : null;
  } catch {
    return null;
  }
}

export function createArtifactCollectionIdsFilter(
  artifactCollectionIds: string[]
): string | undefined {
  const parsedIds = artifactCollectionIds
    .map(id => parseArtifactCollectionId(id))
    .filter((id): id is string => id !== null);

  if (parsedIds.length === 0) {
    return undefined;
  }

  return JSON.stringify(
    toMongo({
      key: {section: 'artifact', name: 'id'},
      op: 'IN',
      value: parsedIds,
    })
  );
}
